"use strict";

exports.__esModule = true;
exports["default"] = exports.CapitalizeText = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _components = require("../../components");

var _theme = require("../../utils/theme");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CapitalizeText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "os-options__CapitalizeText",
  componentId: "sc-1iz3l-0"
})(["text-transform:capitalize;"]);
exports.CapitalizeText = CapitalizeText;
var propTypes = {
  /** Callback to be called when dropdown is clicked */
  onDropDownClick: _propTypes.func,

  /** OS dropdown options */
  osOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    osName: _propTypes.string,
    suiteId: _propTypes.number
  })),

  /** Active OS dropdown option */
  selectedOS: (0, _propTypes.oneOf)(["Windows", "Linux", "Android", "Mac OS"]),

  /** Active OS dropdown suite id */
  selectedOsId: _propTypes.number
};

var optionIcon = function optionIcon(height, color) {
  return {
    Android: /*#__PURE__*/_react["default"].createElement(_components.OsAndroid, {
      fill: color,
      height: height
    }),
    Linux: /*#__PURE__*/_react["default"].createElement(_components.OsLinux, {
      fill: color,
      height: height
    }),
    "Mac OS": /*#__PURE__*/_react["default"].createElement(_components.OsMac, {
      fill: color,
      height: height
    }),
    Windows: /*#__PURE__*/_react["default"].createElement(_components.OsWindows, {
      fill: color,
      height: height
    })
  };
};

var OsOptions = function OsOptions(_ref) {
  var osOptions = _ref.osOptions,
      selectedOS = _ref.selectedOS,
      selectedOsId = _ref.selectedOsId,
      onDropDownClick = _ref.onDropDownClick;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, osOptions ? " " : "", osOptions && /*#__PURE__*/_react["default"].createElement(_components.Dropdown, {
    alignItems: "center",
    containerProps: {
      left: "auto",
      minWidth: "auto"
    },
    display: ["flex", "flex", "inline-flex"],
    justifyContent: "center",
    lineHeight: 5,
    ml: [0, 0, 4],
    mt: [3, 3, 0],
    render: function render(_ref2) {
      var show = _ref2.show;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, optionIcon(18, "blue")[selectedOS], /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
        color: "blue",
        fontSize: 7,
        fontWeight: 1,
        letterSpacing: "-0.33px",
        lineHeight: [1.9, 1.9, 1.25],
        ml: 1,
        mr: 1
      }, selectedOS), show ? /*#__PURE__*/_react["default"].createElement(_components.NavCaretUp, {
        fill: "blue",
        height: "25px",
        width: "25px"
      }) : /*#__PURE__*/_react["default"].createElement(_components.NavCaretDown, {
        fill: "blue",
        height: "25px",
        width: "25px"
      }));
    },
    renderDropdown: function renderDropdown(_ref3) {
      var toggleShowDropdown = _ref3.toggleShowDropdown,
          selected = _ref3.selected;
      return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
        flexDirection: "column",
        width: "208px"
      }, osOptions.map(function (_ref4) {
        var osName = _ref4.osName,
            suiteId = _ref4.suiteId;
        return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
          key: suiteId,
          borderBottom: "1px solid",
          borderColor: "gray-divider",
          cursor: "pointer",
          onClick: function onClick(event) {
            toggleShowDropdown();
            onDropDownClick({
              event: event,
              osName: osName,
              suiteId: suiteId
            });
          },
          px: 2,
          py: 2,
          width: 1
        }, optionIcon(18, selected === suiteId ? _theme.colors["text-light-grey"] : _theme.colors["gray-dark"])[osName], /*#__PURE__*/_react["default"].createElement(CapitalizeText, {
          color: selected === suiteId ? "text-light-grey" : "gray-dark",
          fontSize: 3,
          fontWeight: 1,
          letterSpacing: "0.5px",
          lineHeight: 1.15,
          ml: 1
        }, osName));
      }));
    },
    selected: selectedOsId,
    style: {
      top: "-2px"
    },
    type: "os",
    width: "auto"
  }));
};

OsOptions.propTypes = propTypes;
OsOptions.displayName = "Modules.OsOptions";
var _default = OsOptions;
exports["default"] = _default;